import { CmsObjectWithDefault } from '@components/Cms/types';

export type CwsCreateAccountFooterCtaCmsKey = 'CreateAccount';

export const CwsCreateAccountFooterCtaCmsWithDefault: CmsObjectWithDefault<CwsCreateAccountFooterCtaCmsKey> = {
    CreateAccount: {
        cmsId: 101957,
        defaultTranslation: 'Create account',
    },
};
